/**
 * Check if the tab bar should be displayed or not.
 *
 * @param {string[]} options - An array of regular expressions to match the routes that should not display the tab bar.
 * @returns {boolean} True if the tab bar should be displayed, false otherwise.
 */
export function isTabBarVisible(options: { routesWithoutTabBarRegexps: string[] }): boolean {
  let isTabBarHidden = false;

  options.routesWithoutTabBarRegexps.forEach((pattern: string) => {
    const regex = new RegExp(pattern, "gm");
    let match;

    while ((match = regex.exec(window.location.pathname)) !== null) {
      if (match.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      if (match.length > 0) {
        isTabBarHidden = true;
        break;
      }
    }
  });

  return !isTabBarHidden;
}
